import type {AxiosError} from "axios";
import {isAxiosError} from "axios";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function axiosErrorToString(error: any): string {
    if (isAxiosError(error)) {
        const axiosError: AxiosError = error;
        const contentType = axiosError.response?.headers['content-type'];
        if (typeof contentType === 'string' && contentType.includes('text/html')) {
            // Do not show HTML errors
            return String(axiosError.response?.statusText);
        }
        if (axiosError.response?.data) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const data = axiosError.response?.data as any;
            const backendMessage = backendErrorMessage(data);
            if (backendMessage) {
                return backendMessage;
            }
            const keys = Object.keys(data);
            return keys.map(k => `${k}: ${data[k]}`).join(', ');
        }
        if (axiosError.response?.statusText) {
            return String(axiosError.response.statusText);
        }
        if (axiosError.message) {
            return String(axiosError.message);
        }
    }
    if (error) {
        return String(error);
    }
    return 'Unknown error';
}

/**
 * Backend errors in this API are typically `{msg: "..."}`.
 * Some endpoints use `message` or DRF's `detail` instead.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function backendErrorMessage(data: any): string | undefined {
    if (typeof data === 'string' && data.trim()) {
        return data;
    }
    if (!data || typeof data !== 'object') {
        return undefined;
    }
    for (const key of ['msg', 'message', 'detail']) {
        const value = data[key];
        if (typeof value === 'string' && value.trim()) {
            return value;
        }
    }
    return undefined;
}
